import { Col, Container, Row, Stack } from "react-bootstrap"

const HireUIUXDesignerContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Creative UI/UX Designers to Elevate User Experience
                        </h2>
                        <p>
                            Want a product that’s not just functional but truly delightful to use? Our UI/UX designers craft visually stunning, user-centric designs that enhance engagement, improve usability, and boost conversion rates — across web and mobile platforms.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire UI/UX Designers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>User-Centered Design Approach</b>
                                <p>
                                    We design with real users in mind, ensuring intuitive navigation, clean layouts, and seamless interactions that align with user behavior.
                                </p>
                            </li>
                            <li>
                                <b>Wireframes, Prototypes & Design Systems</b>
                                <p>
                                    Get everything from low-fidelity wireframes to clickable prototypes and reusable design systems to streamline collaboration and development.
                                </p>
                            </li>
                            <li>
                                <b>Mobile-First & Responsive Design</b>
                                <p>
                                    Our designs adapt beautifully to all screen sizes — from smartphones to desktops — ensuring a consistent and polished user experience.
                                </p>
                            </li>
                            <li>
                                <b>UX Audits & Optimization</b>
                                <p>
                                    We identify pain points in existing products and suggest actionable improvements based on usability testing and analytics.
                                </p>
                            </li>
                            <li>
                                <b>Flexible Hiring Engagement</b>
                                <p>
                                    Hire UI/UX designers on a part-time, full-time, or hourly basis — whatever suits your project scope and speed.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our UI/UX Design Services
                        </h2>
                        <ul>
                            <li>UI Design for Web & Mobile Apps</li>
                            <li>UX Research & User Journey Mapping</li>
                            <li>Wireframing & Interactive Prototyping</li>
                            <li>Design System & Component Library Creation</li>
                            <li>Website & Dashboard Redesign</li>
                            <li>Usability Testing & UX Audits</li>
                            <li>Cross-platform Design & Responsive Layouts</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Design a Better Digital Experience with Us
                        </h2>
                        <p>
                            Our UI/UX designers combine creativity with strategy to help your brand stand out and your users stay engaged. Whether launching a new product or revamping an old one, we’re ready to help. Get in touch for a free consultation and design proposal.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireUIUXDesignerContent;
